import { SimpleGrid, Button } from '@chakra-ui/react'
import { OAuthOption } from 'node_modules/thirdweb/dist/types/wallets/types'
import { Image } from '@/components/HOC/Image'
import { socialsMethods } from './socialsMethods'
import { isWebView } from '@/helpers/device'
import { useAppToast } from '@/hooks/useAppToast'
import { useTranslation } from 'next-i18next/pages'

export const SocialMedia = ({ handleSocialConnect }: { handleSocialConnect: (strategy: OAuthOption) => void }) => {
  const { t } = useTranslation()
  const isWebview = false
  // isWebView()
  const toast = useAppToast()

  return (
    <SimpleGrid display={{ base: 'grid', sm: 'flex', md: 'grid' }} columns={6} gap={2}>
      {socialsMethods.map((social, index) => (
        <Button
          key={index}
          minW={{ base: '44px', sm: 16, md: 0 }}
          maxW={16}
          variant={'secondary'}
          h={'auto'}
          alignItems={'center'}
          justifyContent={'center'}
          p={0}
          aspectRatio={1}
          bg={'ninja.500'}
          rounded={'xl'}
          onClick={() => {
            isWebview
              ? toast.onError({ custom: { title: t('messages.social-auth-not-supported') } })
              : handleSocialConnect(social.strategy as OAuthOption)
          }}
        >
          <Image w={{ base: '50%', sm: 8 }} h={{ base: '50%', sm: 8 }} src={social.icon} alt="" />
        </Button>
      ))}
    </SimpleGrid>
  )
}
